import axios from 'axios';

export default {
  selectors: (params = {}, config = {}) => axios.get('units/selectors', { params, ...config }),
};
